import { getUserInfoApi, getUserProfile, loginApi } from 'utils/apis';
import { authAction } from './auth.slice';
import AuthStore from 'common/authStore';
import { STATUS_CODE } from 'common/constants';
import { encrypt, parseJwt } from 'utils/functions';

export const fetchUserDetails = (payload) => async (dispatch) => {
  try {
    dispatch(authAction.getUserInfo());
    const response = await loginApi(payload);
    console.log('response', response);

    if (response.status === STATUS_CODE.Ok) {
      const token = response?.data?.data;

      AuthStore.accessToken = token;

      const tokenObj = parseJwt(token);
      const { Email, Name, Surname } = tokenObj;
      AuthStore.firstName = Name;
      try {
        dispatch(authAction.startLoading());
        const responseProfile = await getUserProfile(Email);
        console.log('response.status', responseProfile.status);
        if (responseProfile.status === STATUS_CODE.Ok) {
          const { user_Role } = responseProfile.data.data;
          const userroleEncrypt = encrypt(user_Role);
          localStorage.setItem('usertype', userroleEncrypt);
          dispatch(authAction.setUserProfile(responseProfile.data.data));
        }
      } catch (err) {
        console.log(err);
        // dispatch(authAction.stopLoading());
      }
      dispatch(
        authAction.setUserInfo({
          userFirstName: Name,
          userLastName: Surname,
          emailId: Email
        })
      );
    } else {
      dispatch(authAction.authError());
    }
  } catch (e) {
    // if (e.response?.status == 401) {
    //   dispatch(authAction.setError({ isError: true, error: e }));
    // }
    if (e.response?.status == 400) {
      dispatch(authAction.setError({ isError: true, error: e.response.data }));
    }
    dispatch(authAction.authError());
  }
};

export const fetUserRole = (payload) => async (dispatch) => {
  try {
    dispatch(authAction.getUserRole());
    const response = await getUserInfoApi(payload);

    if (response.statusText === 'OK' && response.status === STATUS_CODE.Ok) {
      const data = response?.data?.data;
      // console.log('data', data);
      sessionStorage.setItem('roles', JSON.stringify(data));

      // dispatch(
      //   authAction.setUserInfo({
      //     userFirstName: tokenObj.Name,
      //     userLastName: tokenObj.Surname,
      //     emailId: tokenObj.Email
      //   })
      // );

      dispatch(authAction.stopLoading());
    } else {
      dispatch(authAction.stopLoading());
      // dispatch(authAction.authError());
    }
  } catch (e) {
    dispatch(authAction.stopLoading());
    console.log(e);
  }
};

export const setUserData = (token) => async (dispatch) => {
  if (token !== '') {
    const tokenObj = parseJwt(token);
    AuthStore.firstName = tokenObj.Name;
    dispatch(
      authAction.setUserInfo({
        userFirstName: tokenObj.Name,
        userLastName: tokenObj.Surname,
        emailId: tokenObj.Email
      })
    );
  }
};

export const fetchUserProfile = (payload) => async (dispatch) => {
  try {
    dispatch(authAction.startLoading());
    const response = await getUserProfile(payload);
    // console.log('response.status', response.status);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(authAction.setUserProfile(response.data.data));
    }
  } catch (err) {
    dispatch(authAction.stopLoading());
  }
};
